module.exports = __webpack_public_path__ + "media/contract/dotted-line-1-e46fa589.png";